const cseData2 = [
  // --- Hard Level (51–100) ---
  {
    id: 51,
    category: "CSE",
    level: "hard",
    question: "Which protocol ensures secure file transfer over the Internet?",
    options: ["Telnet", "SFTP", "HTTP", "FTP"],
    answer: "SFTP",
  },
  {
    id: 52,
    category: "CSE",
    level: "hard",
    question: "What is the purpose of a load balancer in network architecture?",
    options: [
      "Encrypt network packets",
      "Monitor CPU performance",
      "Distribute network traffic across multiple servers",
      "Compress data for storage",
    ],
    answer: "Distribute network traffic across multiple servers",
  },
  {
    id: 53,
    category: "CSE",
    level: "hard",
    question: "What does DNS stand for and what does it do?",
    options: [
      "Data Network System; transfers files",
      "Domain Name System; resolves domain names to IP addresses",
      "Dynamic Number Service; manages ports",
      "Distributed Name Server; stores passwords",
    ],
    answer: "Domain Name System; resolves domain names to IP addresses",
  },
  {
    id: 54,
    category: "CSE",
    level: "hard",
    question: "What is the main difference between TCP and UDP?",
    options: [
      "TCP is connection-oriented; UDP is connectionless",
      "UDP guarantees delivery; TCP does not",
      "Both are connectionless",
      "TCP is slower than UDP",
    ],
    answer: "TCP is connection-oriented; UDP is connectionless",
  },
  {
    id: 55,
    category: "CSE",
    level: "hard",
    question: "What is the primary function of the OS kernel?",
    options: [
      "Manage memory, processes, and hardware",
      "Store user passwords",
      "Compile source code",
      "Control Internet access",
    ],
    answer: "Manage memory, processes, and hardware",
  },
  {
    id: 56,
    category: "CSE",
    level: "hard",
    question: "Which algorithm is used for finding a Minimum Spanning Tree?",
    options: [
      "Dijkstra's Algorithm",
      "Kruskal's Algorithm",
      "Bellman-Ford Algorithm",
      "Prim's Algorithm",
    ],
    answer: "Kruskal's Algorithm",
  },
  {
    id: 57,
    category: "CSE",
    level: "hard",
    question: "Difference between multiprocessing and multithreading?",
    options: [
      "Multiprocessing: multiple CPUs; Multithreading: threads within process",
      "They are the same",
      "Multithreading is slower",
      "Multiprocessing only on single-core CPUs",
    ],
    answer:
      "Multiprocessing: multiple CPUs; Multithreading: threads within process",
  },
  {
    id: 58,
    category: "CSE",
    level: "hard",
    question: "Purpose of B+ Tree in databases?",
    options: [
      "Efficient disk-based search, insert, delete",
      "Balance CPU load",
      "Store cache",
      "Encrypt data",
    ],
    answer: "Efficient disk-based search, insert, delete",
  },
  {
    id: 59,
    category: "CSE",
    level: "hard",
    question: "Difference between deep copy and shallow copy?",
    options: [
      "Deep copy duplicates nested objects; shallow copy references them",
      "Deep copy only copies primitives",
      "Identical in memory",
      "Shallow copy duplicates everything",
    ],
    answer: "Deep copy duplicates nested objects; shallow copy references them",
  },
  {
    id: 60,
    category: "CSE",
    level: "hard",
    question: "What does REST stand for?",
    options: [
      "Rapid Endpoint Service Transfer",
      "Representational State Transfer",
      "Remote Execution System",
      "Resource State Translator",
    ],
    answer: "Representational State Transfer",
  },
  {
    id: 61,
    category: "CSE",
    level: "hard",
    question: "What is React Reconciliation?",
    options: [
      "Redux state update",
      "Comparing virtual DOM to real DOM and updating changed parts",
      "Resetting component state",
      "Merging components",
    ],
    answer: "Comparing virtual DOM to real DOM and updating changed parts",
  },
  {
    id: 62,
    category: "CSE",
    level: "hard",
    question: "Purpose of garbage collector in Java?",
    options: [
      "Handle I/O operations",
      "Automatically reclaim memory of unused objects",
      "Optimize CPU scheduling",
      "Manually free memory",
    ],
    answer: "Automatically reclaim memory of unused objects",
  },
  {
    id: 63,
    category: "CSE",
    level: "hard",
    question: "What is memoization in programming?",
    options: [
      "Cache function results for reuse",
      "Encrypt data",
      "Database normalization",
      "Sorting algorithm",
    ],
    answer: "Cache function results for reuse",
  },
  {
    id: 64,
    category: "CSE",
    level: "hard",
    question: "Primary use of Docker?",
    options: [
      "Create isolated application containers",
      "Handle HTTP requests",
      "Monitor CPU usage",
      "Version control",
    ],
    answer: "Create isolated application containers",
  },
  {
    id: 65,
    category: "CSE",
    level: "hard",
    question: "Role of ARP protocol?",
    options: [
      "Map IP addresses to MAC addresses",
      "Encrypt traffic",
      "Route packets",
      "Resolve domain names",
    ],
    answer: "Map IP addresses to MAC addresses",
  },
  {
    id: 66,
    category: "CSE",
    level: "hard",
    question: "Algorithm used for public-key encryption?",
    options: ["MD5", "AES", "RSA", "SHA-256"],
    answer: "RSA",
  },
  {
    id: 67,
    category: "CSE",
    level: "hard",
    question: "Main disadvantage of recursion?",
    options: [
      "High memory use due to call stack",
      "Cannot debug",
      "Slower than loops",
      "Cannot return values",
    ],
    answer: "High memory use due to call stack",
  },
  {
    id: 68,
    category: "CSE",
    level: "hard",
    question: "What is a race condition?",
    options: [
      "Multiple threads access shared data and outcome depends on timing",
      "Memory fragmented",
      "Threads execute sequentially",
      "CPU runs slower",
    ],
    answer: "Multiple threads access shared data and outcome depends on timing",
  },
  {
    id: 69,
    category: "CSE",
    level: "hard",
    question: "Meaning of coupling in software engineering?",
    options: [
      "Degree of dependency between modules",
      "Database relations",
      "Memory usage",
      "Number of loops in program",
    ],
    answer: "Degree of dependency between modules",
  },
  {
    id: 70,
    category: "CSE",
    level: "hard",
    question: "Which is a NoSQL database?",
    options: ["PostgreSQL", "Oracle", "MongoDB", "MySQL"],
    answer: "MongoDB",
  },
  {
    id: 71,
    category: "CSE",
    level: "hard",
    question: "Which layer of the OSI model handles routing?",
    options: ["Physical", "Application", "Network", "Data Link"],
    answer: "Network",
  },
  {
    id: 72,
    category: "CSE",
    level: "hard",
    question: "What is the main purpose of CDN?",
    options: [
      "Distribute content closer to users for faster access",
      "Secure websites",
      "Compress data",
      "Balance server load",
    ],
    answer: "Distribute content closer to users for faster access",
  },
  {
    id: 73,
    category: "CSE",
    level: "hard",
    question: "Which HTTP method is idempotent?",
    options: ["GET", "PATCH", "DELETE", "POST"],
    answer: "GET",
  },
  {
    id: 74,
    category: "CSE",
    level: "hard",
    question: "Which algorithm is used for cycle detection in graphs?",
    options: ["DFS", "Kruskal", "BFS", "Dijkstra"],
    answer: "DFS",
  },
  {
    id: 75,
    category: "CSE",
    level: "hard",
    question: "What is a binary heap used for?",
    options: [
      "Implementing priority queues efficiently",
      "Sorting arrays",
      "Binary search",
      "Graph traversal",
    ],
    answer: "Implementing priority queues efficiently",
  },
  {
    id: 76,
    category: "CSE",
    level: "hard",
    question: "Main feature of OAuth 2.0?",
    options: [
      "Server monitoring",
      "Delegated authorization without sharing credentials",
      "Database backup",
      "Encrypt network traffic",
    ],
    answer: "Delegated authorization without sharing credentials",
  },
  {
    id: 77,
    category: "CSE",
    level: "hard",
    question:
      "Which design pattern allows object creation without exposing logic?",
    options: ["Singleton", "Observer", "Factory", "Adapter"],
    answer: "Factory",
  },
  {
    id: 78,
    category: "CSE",
    level: "hard",
    question: "Difference between SQL and NoSQL?",
    options: [
      "SQL is relational; NoSQL is non-relational",
      "SQL is faster",
      "NoSQL uses tables",
      "SQL cannot scale horizontally",
    ],
    answer: "SQL is relational; NoSQL is non-relational",
  },
  {
    id: 79,
    category: "CSE",
    level: "hard",
    question: "Purpose of indexes in databases?",
    options: [
      "Speed up query retrieval",
      "Backup data",
      "Encrypt data",
      "Normalize tables",
    ],
    answer: "Speed up query retrieval",
  },
  {
    id: 80,
    category: "CSE",
    level: "hard",
    question: "Which protocol is used to send emails?",
    options: ["FTP", "HTTP", "DNS", "SMTP"],
    answer: "SMTP",
  },
  {
    id: 81,
    category: "CSE",
    level: "hard",
    question: "Main purpose of API rate limiting?",
    options: [
      "Encrypt requests",
      "Compress responses",
      "Prevent server overload",
      "Monitor logs",
    ],
    answer: "Prevent server overload",
  },
  {
    id: 82,
    category: "CSE",
    level: "hard",
    question: "Which data structure is used for BFS?",
    options: ["Tree", "Stack", "Queue", "Graph"],
    answer: "Queue",
  },
  {
    id: 83,
    category: "CSE",
    level: "hard",
    question: "Purpose of TCP three-way handshake?",
    options: [
      "Send packets faster",
      "Close connections",
      "Establish reliable connection between client and server",
      "Encrypt data",
    ],
    answer: "Establish reliable connection between client and server",
  },
  {
    id: 84,
    category: "CSE",
    level: "hard",
    question: "Which is a common hashing algorithm?",
    options: ["SHA-256", "OTP", "RSA", "AES"],
    answer: "SHA-256",
  },
  {
    id: 85,
    category: "CSE",
    level: "hard",
    question: "Which process schedules CPU in OS?",
    options: ["Scheduler", "Compiler", "Loader", "Garbage Collector"],
    answer: "Scheduler",
  },
  {
    id: 86,
    category: "CSE",
    level: "hard",
    question: "What is the purpose of SSL/TLS?",
    options: [
      "Secure communication between client and server",
      "Store passwords",
      "Compress data",
      "Route traffic",
    ],
    answer: "Secure communication between client and server",
  },
  {
    id: 87,
    category: "CSE",
    level: "hard",
    question: "What is a RESTful API?",
    options: [
      "Web API following REST principles",
      "Database API",
      "Encryption service",
      "Server-side script",
    ],
    answer: "Web API following REST principles",
  },
  {
    id: 88,
    category: "CSE",
    level: "hard",
    question: "Which sorting algorithm has O(n log n) worst-case complexity?",
    options: ["Merge Sort", "Selection Sort", "Bubble Sort", "Insertion Sort"],
    answer: "Merge Sort",
  },
  {
    id: 89,
    category: "CSE",
    level: "hard",
    question: "Purpose of JWT in web apps?",
    options: [
      "Database indexing",
      "Encrypt files",
      "Securely transmit information between parties",
      "Monitor server",
    ],
    answer: "Securely transmit information between parties",
  },
  {
    id: 90,
    category: "CSE",
    level: "hard",
    question: "What is the main feature of NoSQL databases?",
    options: [
      "Schema-less and scalable",
      "Always relational",
      "Requires SQL queries",
      "Supports only small data",
    ],
    answer: "Schema-less and scalable",
  },
  {
    id: 91,
    category: "CSE",
    level: "hard",
    question: "What is the main purpose of HTTPS?",
    options: [
      "Encrypt communication between browser and server",
      "Faster data transfer",
      "Load balancing",
      "Database replication",
    ],
    answer: "Encrypt communication between browser and server",
  },
  {
    id: 92,
    category: "CSE",
    level: "hard",
    question: "Which data structure is best for LRU cache?",
    options: ["Array", "Stack", "Doubly Linked List + HashMap", "Queue"],
    answer: "Doubly Linked List + HashMap",
  },
  {
    id: 93,
    category: "CSE",
    level: "hard",
    question: "Which HTTP status code means 'Not Found'?",
    options: ["301", "404", "500", "200"],
    answer: "404",
  },
  {
    id: 94,
    category: "CSE",
    level: "hard",
    question: "Purpose of VPN?",
    options: [
      "Compress files",
      "Encrypt databases",
      "Securely connect to network over public Internet",
      "Speed up server",
    ],
    answer: "Securely connect to network over public Internet",
  },
  {
    id: 95,
    category: "CSE",
    level: "hard",
    question: "Which algorithm is used in Dijkstra's shortest path?",
    options: [
      "Divide & Conquer",
      "Greedy",
      "Dynamic Programming",
      "Brute Force",
    ],
    answer: "Greedy",
  },
  {
    id: 96,
    category: "CSE",
    level: "hard",
    question: "Which layer of TCP/IP handles routing?",
    options: [
      "Transport Layer",
      "Internet Layer",
      "Application Layer",
      "Network Access",
    ],
    answer: "Internet Layer",
  },
  {
    id: 97,
    category: "CSE",
    level: "hard",
    question: "Which protocol is used for secure remote login?",
    options: ["Telnet", "FTP", "SSH", "SMTP"],
    answer: "SSH",
  },
  {
    id: 98,
    category: "CSE",
    level: "hard",
    question: "Which database normal form eliminates partial dependency?",
    options: ["3NF", "1NF", "2NF", "BCNF"],
    answer: "2NF",
  },
  {
    id: 99,
    category: "CSE",
    level: "hard",
    question: "Which protocol converts domain names to IP addresses?",
    options: ["SMTP", "DNS", "ARP", "HTTP"],
    answer: "DNS",
  },
  {
    id: 100,
    category: "CSE",
    level: "hard",
    question: "Which design pattern ensures a class has only one instance?",
    options: ["Factory", "Adapter", "Observer", "Singleton"],
    answer: "Singleton",
  },
];

export default cseData2;
